var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIonGauge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 157.44884 300.00001",
    id: "svg1719",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ion-gauge",
    style: {
      display: "inline"
    },
    transform: "translate(-199.42654 -188.65913)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 7.32897,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect766",
    d: "M241.83166 409.93471h73.84926v75.05994h-73.84926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#333",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 7.32897,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect768",
    d: "M203.09102 192.32361h150.11987v217.61103H203.09102Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect772",
    style: {
      fill: "#ffd42a",
      strokeWidth: 6.48412
    },
    d: "M205.30935 192.12397c-1.21808 0-2.18945.97139-2.18945 2.18946v212.48242c0 1.21808.97137 2.20508 2.18945 2.20508h24.63477c1.21808 0 2.20508-.987 2.20508-2.20508V194.31343c0-1.21807-.98701-2.18946-2.20508-2.18946h-24.63477zm121.0293 0c-1.21807 0-2.20508.97139-2.20508 2.18946v212.95508c0 1.21799.98701 2.20507 2.20508 2.20507h25.26367c1.21808 0 2.20508-.98708 2.20508-2.20507V194.31343c0-1.21807-.987-2.18946-2.20508-2.18946h-25.26367zm-79.64649 114.80664c-1.21807 0-2.19726.98115-2.19726 2.19922v24.24024c0 1.21807.97919 2.19922 2.19726 2.19922h26.66797c1.21808 0 2.19922-.98115 2.19922-2.19922v-24.24024c0-1.21807-.98114-2.19922-2.19922-2.19922h-26.66797zm36.4043.24219c-1.21807 0-2.19726.98115-2.19726 2.19922v24.24219c0 1.21807.97919 2.19726 2.19726 2.19726h26.66797c1.21807 0 2.19922-.97919 2.19922-2.19726v-24.24219c0-1.21807-.98115-2.19922-2.19922-2.19922h-26.66797zm-36.88867 34.94922c-1.21807 0-2.19922.98115-2.19922 2.19922v24.24023c0 1.21808.98115 2.19922 2.19922 2.19922h26.66797c1.21807 0 2.19726-.98114 2.19726-2.19922v-24.24023c0-1.21807-.97919-2.19922-2.19726-2.19922h-26.66797zm37.375 0c-1.21807 0-2.19922.98115-2.19922 2.19922v24.24023c0 1.21808.98115 2.19922 2.19922 2.19922h26.66797c1.21807 0 2.19922-.98114 2.19922-2.19922v-24.24023c0-1.21807-.98115-2.19922-2.19922-2.19922h-26.66797z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000",
      strokeWidth: 7.32897
    },
    id: "rect784",
    width: 64.072205,
    height: 68.926155,
    x: 245.95009,
    y: 209.85184,
    rx: 2.1986909,
    ry: 2.1986909
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#000",
      strokeWidth: 7.32897
    },
    id: "path786",
    d: "m293.5899 335.10741-8.58906-5.4411 9.00667-4.7178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 4.85114
    },
    id: "path788",
    d: "M285.90807 318.9398c1.53209-4.82836 7.45426-7.75054 13.00809-6.41859 5.55385 1.332 8.91507 6.48056 7.38297 11.30896-1.53209 4.82835-7.45425 7.75053-13.00809 6.41854"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect790",
    style: {
      display: "inline",
      fill: "#000",
      strokeWidth: 7.32897
    },
    d: "M304.76618 346.81887c-1.21807 0-2.2044.98634-2.2044 2.20441v8.35957h-10.39225c-.29316 0-.57533.0513-.83024.15757l-.0147-2.43343-8.5886 5.98337 8.66021 5.84031-.0147-2.57658c.24333.0924.51011.14292.78735.14292h13.88495c.94596 0 1.7498-.59658 2.06129-1.43142.21473-.34007.34372-.74008.34372-1.17381v-12.86864c0-1.21808-.98633-2.20441-2.2044-2.20441z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path796",
    style: {
      display: "inline",
      fill: "#000",
      strokeWidth: 7.32897
    },
    d: "m259.74741 308.85709-7.68685 13.44125 4.29435-.0147c-.16492.30855-.25799.66914-.25799 1.04497v7.80132c0 1.21807.97204 2.19012 2.19011 2.19012h3.00606c1.21807 0 2.19004-.97205 2.19004-2.19012v-7.80132c0-.3877-.0967-.75782-.2719-1.07355l4.33728-.0147z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path802",
    style: {
      display: "inline",
      fill: "#000",
      strokeWidth: 7.32897
    },
    d: "M257.91516 344.34249c-1.21807 0-2.19012.98633-2.19012 2.20441v7.80132c0 .37597.0924.73605.25798 1.04496l-4.29433-.0147 7.68684 13.44119 7.80132-13.38395-4.33728-.0147c.17516-.31588.2719-.68526.2719-1.07362v-7.80133c0-1.21807-.97204-2.2044-2.19011-2.2044z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonGauge);
export default __webpack_public_path__ + "static/media/ion-gauge.ee6aee2741ba0885c384f77afd02916c.svg";
export { ForwardRef as ReactComponent };